<template>
   <section class="vue-select" >
     <span class="select" @click="toggleOption()" :class="{'topSelect':isShowOption}"> {{ cityValue?cityValue:tip }} </span>
     <ul class="option-box" v-if="isShowOption" >
       <li @click="changeValue('')" value="" v-if="tip">{{tip}}</li>
       <li @click="changeValue(item)" v-for="(item, index) in list" :value="item"  :key="index">
         {{ item }}
       </li>
     </ul>
   </section>
</template>
<script>
  export default {
    data(){
      return{
        isShowOption: false,
        currentValue: '',
        data: []
      }
    },
    mounted(){
       //點擊外部隱藏下拉
      document.addEventListener('click',(e)=>{
        let thisClassName = e.target.className;
        if(thisClassName != 'select' && thisClassName != 'select topSelect' && thisClassName != 'option-box'){
          this.isShowOption = false;
        }
      })
    },
    methods: {
      changeValue(val){
        this.currentValue = val;
        this.isShowOption = false;
        //this.setList();
        this.$emit("valueChanged", {
          currentValue:this.currentValue,
          type:this.type
        });
      },
      toggleOption(){
        this.isShowOption = !this.isShowOption;
      },
      leaveSelect(){
        this.isShowOption = false;
      },
      setList(){
        let list = [];
        for(let i=0;i<this.data.length;i++){
          if(this.data[i] != this.cityValue){
            list.push(this.data[i])
          }
        }
        this.data = list;
      }
    },
    props: ['cityValue','list','tip','type']
  }
</script>
<style scoped lang="scss">
.vue-select{
  display: inline-block;
  width: 100%;
  height: 100%;
/*  height: 48px;*/
  position: relative;
  .select{
    display: block;
    width: 100%;
/*    height: 70px;
    line-height: 70px;*/
    height: 100%;
   /* border: 1px solid #231916;*/
    border: 1px solid #908782;
    border-radius: 35px;
    padding-left: 28px;
    background: url(../../assets/images/selectIcon.svg) no-repeat 97% center;
    z-index: 9;
    position: absolute;
    color: #000;
    font-size: 17px;
  }
  input:focus{
    & + .option-box{
      display: block;
          color:red;

    }
  }
.select.topSelect{
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;

}

  .option-box{
    width: 100%;
    position: absolute;
    border: 1px solid #231916;
    border-top:0;
    border-radius: 0 0 35px 35px;
    background-color: #FFFFFF;
   /* box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);*/
    z-index: 7;
    padding:30px 0 30px;
    top: 39px;
    left: 0;
    max-height: 460px;
    overflow: auto;
    li{
     /* height: 44px;*/
      font-size: 17px;
      letter-spacing: 0;
      color: #000;
      cursor: pointer;
   /*   padding-top:6px;*/
      padding-left: 28px;
      &.active, &:hover{

        background-color: #F8F8F8;
      }
    }
  }

}
@media (max-width: 1080px) {
  .vue-select {
    .option-box{
      padding: 10px 0 10px;
      max-height: 420px;
      li{
        line-height: 45px;
        font-size: 15px;
      }
    }
    .select{
      font-size: 16px;
      letter-spacing: 1.5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/default/vue-select2.vue